// import './App.css';
import React from "react";
import {
    BrowserRouter,
} from "react-router-dom";
import RouteComponent from "./router/RouteComponent";
import ThemeProvider from "./theme";

import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

function App() {
    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [rtlPlugin],
    });

    return (
        <ThemeProvider>
            <CacheProvider value={cacheRtl}>
                <BrowserRouter>
                    <RouteComponent />
                </BrowserRouter>
            </CacheProvider>
        </ThemeProvider>
    );
}

export default App;


